import { render, staticRenderFns } from "./SciApplicationReviews.vue?vue&type=template&id=c7edec0a"
import script from "./SciApplicationReviews.vue?vue&type=script&lang=js"
export * from "./SciApplicationReviews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports